import React from "react";

import {
  ShieldCheck,
  Layers3,
  Lock,
  BadgeCheck,
} from "lucide-react";

import "../styles/footer.css";

const Footer = () => {

  const currentYear =
    new Date().getFullYear();

  return (

    <footer className="rcs-modern-footer">

      {/* LEFT */}

      <div className="rcs-modern-footer-left">

        <div className="rcs-modern-footer-icon">

          <ShieldCheck size={18} />

        </div>

        <p>

          Excellence is the
          gradual result of
          always striving to
          do better.

        </p>

      </div>

      {/* CENTER */}

      <div className="rcs-modern-footer-divider" />

      {/* RIGHT */}

      <div className="rcs-modern-footer-right">

        <div className="rcs-modern-footer-item">

          <ShieldCheck size={16} />

          Secure

        </div>

        <span>•</span>

        <div className="rcs-modern-footer-item">

          <Lock size={16} />

          Reliable

        </div>

        <span>•</span>

        <div className="rcs-modern-footer-item">

          <BadgeCheck size={16} />

          Trusted

        </div>

        <span>•</span>

        <div className="rcs-modern-footer-item">

          <Layers3 size={16} />

          Efficient

        </div>

      </div>

      {/* YEAR */}

      <div className="rcs-modern-footer-year">

        © {currentYear} RCS

      </div>

    </footer>
  );
};

export default Footer;